// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__19AFE","name":"Header_name__tt1gW","birthday":"Header_birthday__2RwMc","skeleton":"Header_skeleton__1mGa5"};